<template>
  <div class="relative mt-4">
    <template v-if="common.getPermissions('financials', 'base', 'view')">
      <shipblu-table
      :sst="true"
        :max-items="maximumItems"
        :data="refunds"
        :tableLoader="tableLoader"
      >
        <template slot="header">
          <div class="lg:w-auto w-full">
            <table-filter icon="BarChart2Icon" filterLabel="Status" :filters="filters" :statusFilters="statusFilters" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
          </div>
        </template>

        <template slot="thead">
          <shipblu-th>{{$t('Request Date')}}</shipblu-th>
          <shipblu-th>{{$t('Withdraw Amount')}}</shipblu-th>
          <shipblu-th>{{$t('Status')}}</shipblu-th>
        </template>

        <template slot-scope="{ data }">
          <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <shipblu-td :data="data[indextr].merchant">
              {{ new Date(data[indextr].created).toLocaleDateString('fr-CA') }}
            </shipblu-td>

            <shipblu-td :data="data[indextr].requested_amount">
              {{data[indextr].requested_amount}}
            </shipblu-td>

            <shipblu-td :data="data[indextr].status">
              <div @click="`${data[indextr].status === 'rejected' ? showRejectionReason(data[indextr].id, data[indextr].comment) : '' }`" :class="`${data[indextr].status === 'rejected' ? 'underline' : ''}`">
                {{data[indextr].status === 'requested' ? $t('Refund Requested') : data[indextr].status === 'under_review' ? $t('Under Review') : data[indextr].status === 'refunded' ? $t('Approved') : $t('Rejected')}}
              </div>
            </shipblu-td>
          </shipblu-tr>
        </template>
      </shipblu-table>
      <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />

      <shipblu-prompt
        @close="closeModal"
        :active.sync="rejectionReasonModal"
        :title="$t('Rejection Reason')"
        :buttons-hidden="true">
        <div>
          <p class="text-dried-lavender-flowers">{{ $t(rejectionReason) }}</p>
        </div>
      </shipblu-prompt>
    </template>

    <template v-else>
      <NoPermission class="mt-6" :action="$t('view this page')"/>
    </template>
  </div>
</template>

<script>
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'
import TableFilter from './components/TableFilter.vue'
import ShipbluPrompt from '../../layouts/components/ShipBluPrompt.vue'
import vSelect from 'vue-select'
import { sendRequest } from '../../http/axios/requestHelper'
import common  from '@/assets/utils/common'
import NoPermission from './components/NoPermission.vue'

export default {
  data () {
    return {
      common,
      statusFilters: [
        {
          name: 'All',
          value: 'all'
        },
        {
          name: 'Refund Requested',
          value: 'requested'
        },
        {
          name: 'Under Review',
          value: 'under_review'
        },
        {
          name: 'Approved',
          value: 'refunded'
        },
        {
          name: 'Rejected',
          value: 'rejected'
        }
      ],
      filters: [],
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      refunds: [],
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      tableLoader: false,
      selectReasonModal: false,
      filterValue: '',
      withdrawalsId: '',
      reason: '',
      rejectionReason: '',
      rejectionReasonModal: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push(
        {
          query: {
            tab: this.$route.query.tab,
            filter: this.filters,
            page: this.currentPage
          }
        }
      ).catch(() => {})
      this.loadRefundRequests()
    },
    '$route.query.filter' () {
      if (!this.$route.query.filter) {
        this.filters = []
        this.loadRefundRequests()
      }
    },
    '$route.query.tab' () {
      this.$router.push(
        {
          query: {
            tab: this.$route.query.tab,
            filter: this.filters,
            page: 1
          }
        }
      ).catch(() => {})
    }
  },
  computed: {
    reasons () {
      return [
        { id: 1,
          name: this.$t('Insufficient Balance')
        },
        { id: 2,
          name: this.$t('Zero COD Wih On Hold Orders')
        },
        { id: 3,
          name: this.$t('No Payout Method')
        },
        { id: 4,
          name: this.$t('Wrong Bank Details')
        },
        { id: 5,
          name: this.$t('Duplicate Request')
        },
        { id: 6,
          name: this.$t('Others...')
        }
      ]
    }
  },
  methods: {
    openRejectionModal (id) {
      this.selectReasonModal = true
      this.$validator.resume()
      this.withdrawalsId = id
    },
    showRejectionReason (id, comment) {
      this.rejectionReasonModal = true
      this.withdrawalsId = id
      this.rejectionReason = comment
    },
    loadRefundRequests () {
      this.tableLoader = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}&status=${this.filters}`
      sendRequest(false, false, this, `api/v1/merchant-wallet-refunds/${query}`, 'get', null, true,
        (response) => {
          this.refunds = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
        }
      )
    },
    changeFilter () {
      this.filters = [this.filterValue]
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadRefundRequests()
    },
    closeModal () {
      this.selectReasonModal = false
      this.rejectionReasonModal = false
      this.$validator.pause()
      this.loadRefundRequests()
      this.withdrawalsId = ''
      this.reason = ''
      this.rejectionReason = ''
    }
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination,
    TableFilter,
    ShipbluPrompt,
    vSelect,
    NoPermission
  },
  created () {
    this.routeQuery = { ...this.$route.query };
    ['subTab', 'filter'].forEach(key => delete this.routeQuery[key])
    this.$router.push({ query: { ...this.routeQuery } }).catch(() => {})
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    this.loadRefundRequests()
  }
}
</script>